RivalIQ.module('data', function (data, App, Backbone, Marionette, $, _) {

    'use strict';

    const Landscapes = RivalIQ.data.CacheLayer.extend({
        name: 'Landscapes',
        cacheKeys: [
            'account_id'
        ],

        loadData: function (attrs) {
            const landscapes = new RivalIQ.collections.Landscapes();
            _.extend(landscapes, attrs);

            return landscapes.fetch().then(function () {
                return landscapes;
            });
        },

        fetch: function (account) {
            const me = this;
            account = account || RivalIQ.state.account;

            return me.getOrLoad({
                account_id: account.id
            });
        }
    });

    data.landscapes = new Landscapes();
});
